module.exports = __webpack_public_path__ + "img/active_managers.9f6511de.png";